import { useMemo } from "react";

export const useArraysIntersect = <T extends string>(
  a: Array<T>,
  b: Array<T>
) => {
  return useMemo(() => a.some(item => b.includes(item)), [a, b]);
};
